import { useEffect, useMemo, useState } from "react"
import { Button, Table, DatePicker, message, Space } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import moment from "moment"
import _ from 'lodash'

const { Column } = Table

type fetchParams = {
    store_id: undefined | string,
    date: any
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        date: null
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)

    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    // 列表数据
    const [data, setData] = useState<any>([])
    // 汇总数据
    const [summaryData, setSummaryData] = useState<any>([])

    const [loading, setLoading] = useState<boolean>(false)
    const [summaryLoading, setSummaryLoading] = useState<boolean>(false)

    // 权限数据获取
    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        if (fetchOtherParams.date) {
            fetch({ pagination, fetchOtherParams })
        }
    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        if (fetchOtherParams.date) {
            const p = { ...pagination }
            p.current = 1

            fetch({ pagination: p, fetchOtherParams })

        } else {
            message.error('必须选择日期')
        }
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)
        setSummaryLoading(true)

        // 清空汇总数据
        setSummaryData("")

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        if (params.date) {
            params.month = moment(params.date).format('YYYY-MM')
            delete params.date
        }

        axiosTable.get('/markting_center/report/store_results/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
                // 设置汇总数据
                setSummaryData([response.store_results_summary])
            }

            setLoading(false)
            setSummaryLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1
        setPagination(p)

        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    // 数据导出
    const exportExcel = () => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.showSizeChanger

        let params: any = { ...fetchOtherParams }

        if (params.date) {
            params.month = moment(params.date).format('YYYY-MM')
            delete params.date
        }

        baseAxiosComplete('/markting_center/report/store_results/excel', {
            params: {
                ...iPagination,
                ...params
            }

        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    return (<div className="common-page">
        {/* 营销中心 -> 营销报表 -> 门店业绩报表 */}
        <BreadCrumb position={['营销中心', '门店业绩报表']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores value={fetchOtherParams.store_id} onChange={(v: string) => {
                        handleChange(v, 'store_id')
                    }} />
                </div>
                <DatePicker style={{ width: '140px', marginRight: 8, marginBottom: 12 }} className="fl" placeholder={'日期'} picker="month" value={fetchOtherParams.date} onChange={(v: any) => { handleChange(v, 'date') }} />
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('导出') && <Button onClick={() => { exportExcel() }} type="dashed" >导出</Button>}
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} pagination={pagination} onChange={handleTableChange}>
                <Column title="门店名称" dataIndex="store_name" key="store_name" />
                <Column title="业绩目标" dataIndex="target" key="target" />
                <Column title="完成率" dataIndex="finish_per" key="finish_per" />
                <Column title="签单数" dataIndex="deal_count" key="deal_count" />
                <Column title="合同总金额" dataIndex="agreement_amount" key="agreement_amount" />
                <Column title="实收总金额" dataIndex="pay_amount" key="pay_amount" />
                <Column title="实收总尾款" dataIndex="left_pay_amount" key="left_pay_amount" />
            </Table>
        </div>

        {/* 汇总数据 */}
        <div className="common-main">
            <h3>汇总</h3>

            <Table loading={summaryLoading} dataSource={summaryData} scroll={{ x: 'max-content' }} bordered={true} >
                <Column title="总业绩目标" dataIndex="target" key="target" />
                <Column title="总完成率" dataIndex="finish_per" key="finish_per" />
                <Column title="总签单数" dataIndex="deal_count" key="deal_count" />
                <Column title="总合同金额" dataIndex="agreement_amount" key="agreement_amount" />
                <Column title="总实收金额" dataIndex="pay_amount" key="pay_amount" />
                <Column title="总实收尾款" dataIndex="left_pay_amount" key="left_pay_amount" />
            </Table>
        </div>
    </div>)
}